import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Customer } from "../../models/customer.model";
import { Dept, DeptDetail } from "../../models/dept.model";
import Shop from "../../models/shop.model";
import { Supplier } from "../../models/supplier.model";

@Component({
  selector: "ngx-dialog-print-depts",
  templateUrl: "dialog-print-depts.component.html",
  styleUrls: ["dialog-print-depts.component.scss"],
})
export class DialogPrintDeptsComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() shop?: Shop;
  @Input() mode?: string;
  @Input() objects?: any[] = [];
  @Input() saleAmount = 0;
  @Input() paidAmount = 0;
  @Input() debitAmount = 0;

  @ViewChild("printBtn") printBtn: ElementRef<HTMLElement>;

  loading = false;
  printing = false;
  displayName = "";

  currentDate: Date = new Date();

  constructor(
    protected ref: NbDialogRef<DialogPrintDeptsComponent>,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          this.shopId = user.shopId ? user.shopId : user.uid;
          this.displayName = user.displayName ? user.displayName : user.email;
        } else {
          this.uid = "anonymous";
          this.shopId = "anonymous";
          this.displayName = "";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.print();
    }, 1000);
  }

  cancel() {
    this.ref.close();
  }

  print() {
    this.printing = true;
    let el: HTMLElement = this.printBtn.nativeElement;
    el.click();
    this.ref.close(true);
  }
}
